























import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ConvenzioneTirReInsReview extends Vue {
  @Prop() docInfo!: DocConvenzione;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocConvenzione;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idConvenzione: this.docInfo.idConvenzione,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      indirizzoIstituto: this.docInfo.indirizzoIstituto,
      capIstituto: this.docInfo.capIstituto,
      comuneIstituto: this.docInfo.comuneIstituto,
      provinciaIstituto: this.docInfo.provinciaIstituto,
      telefonoIstituto: this.docInfo.telefonoIstituto,
      emailIstituto: this.docInfo.emailIstituto,
      codiceFiscaleIstituto: this.docInfo.codiceFiscaleIstituto,
      dirigenteIstituto: this.docInfo.dirigenteIstituto,
      luogoNascitaDirigenteIstituto: this.docInfo.luogoNascitaDirigenteIstituto,
      dataNascitaDirigenteIstituto: this.docInfo.dataNascitaDirigenteIstituto,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      pecAzienda: this.docInfo.pecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      luogoNascitaRappresentanteAzienda: this.docInfo
        .luogoNascitaRappresentanteAzienda,
      dataNascitaRappresentante: this.docInfo.dataNascitaRappresentante,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaIstituto: this.docInfo.firmaIstituto,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate,
      codAteco: this.docInfo.codAteco,
      codIstat: this.docInfo.codIstat,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      tutorAziendale: this.docInfo.tutorAziendale,
      tutorFormativo: this.docInfo.tutorFormativo
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }

    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      // footer: function(/*currentPage, pageCount*/) {
      //   return [
      //     {
      //       image: images.authFooter,
      //       width: "560",
      //       height: "80",
      //       margin: [20, 0]
      //     }
      //   ];
      // },
      // // ******** HEADER ******** //
      // header: function(/*currentPage, pageCount, pageSize*/) {
      //   // you can apply any logic and return any valid pdfmake element

      //   return [
      //     {
      //       // image: images.authHeader,
      //       image: images.authHeader,
      //       width: "525",
      //       height: "90",
      //       margin: [35, 0]
      //     }
      //   ];
      // },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        // {
        //   // image: images.authHeader,
        //   image: images.authHeader,
        //   width: "525",
        //   height: "90",
        //   margin: [35, 0]
        // },
        {
          image: images.authHeader,
          width: 525
          //alignment: "right"
        },
        {
          text:
            "Convenzione stipulata in data " +
            this.elements.dataDocumento +
            " con protocolo n. " +
            this.elements.numeroProtocollo,
          style: "bodyText",
          margin: [0, 20, 0, 20]
        },
        {
          text: "CONVENZIONE DI TIROCINIO",
          alignment: "center",
          bold: true,
          fontSize: 16,
          margin: [0, 0, 0, 0]
        },
        {
          text: "INSERIMENTO/REINSERIMENTO",
          alignment: "center",
          bold: true,
          fontSize: 16
        },
        {
          text: "TRA",
          alignment: "center",
          bold: true,
          fontSize: 16
        },
        {
          text: "Soggetto Promotore",
          bold: true,
          style: "bodyText",
          margin: [0, 5, 0, 10]
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Istituto", style: "tableTitle" },
                {
                  text: this.elements.denominazioneIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                { text: this.elements.indirizzoIstituto, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.capIstituto +
                    " " +
                    this.elements.comuneIstituto +
                    " " +
                    this.elements.provinciaIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoIstituto, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: "didattica@vallauri.edu", style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: "CNISO1700C@PEC.ISTRUZIONE.IT", style: "tableText" }
              ],
              [
                { text: "Codice Fiscale / Partita IVA", style: "tableTitle" },
                {
                  text: this.elements.codiceFiscaleIstituto,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Dirigente Scolastico/Legale Rappresentante",
                  style: "tableTitle"
                },
                { text: this.elements.dirigenteIstituto, style: "tableText" }
              ],
              [
                { text: "Nato a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ]
            ]
          }
        },
        {
          text: "E",
          alignment: "center",
          bold: true,
          fontSize: 16,
          margin: [0, 5, 0, 0]
        },
        {
          text: "Soggetto Ospitante",
          bold: true,
          style: "bodyText",
          margin: [0, 5, 0, 10]
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Azienda", style: "tableTitle" },
                { text: this.elements.denominazioneAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo sede legale", style: "tableTitle" },
                { text: this.elements.indirizzoAzienda, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.capAzienda +
                    " " +
                    this.elements.comuneAzienda +
                    " " +
                    this.elements.provinciaAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: this.elements.emailAzienda, style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: this.elements.pecAzienda, style: "tableText" }
              ],
              [
                { text: "Codice fiscale / Partita IVA", style: "tableTitle" },
                { text: this.elements.pIvaAzienda, style: "tableText" }
              ],
              [
                {
                  text: "Titolare / Legale Rappresentante",
                  style: "tableTitle"
                },
                {
                  text: this.elements.rappresentanteAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaRappresentanteAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaRappresentante,
                  style: "tableText"
                }
              ]
            ]
          }
        },
        {
          text: "Premesso",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Il tirocinio è una misura formativa di politica attiva, finalizzata a creare un contatto diretto tra un soggetto ospitante e il tirocinante allo scopo di favorirne l’arricchimento del bagaglio di conoscenze, l’acquisizione di competenze professionali e l’inserimento o il reinserimento lavorativo. Il tirocinio consiste in un periodo di orientamento al lavoro e di formazione in situazione che non si configura come un rapporto di lavoro. I Tirocini inserimenti/reinserimento, sono finalizzati ad agevolare le scelte professionali e l’occupabilità dei giovani nel percorso di transizione tra scuola e lavoro mediante una formazione a diretto contatto con il mondo del lavoro. La Regione Piemonte con DGR n. 85-6277 del 22/12/2017 ha regolamentato la disciplina regionale dei tirocini extracurriculari (formativi e di orientamento e di inserimento/reinserimento lavorativo).",
          style: "bodyText",
          pageBreak: "after"
        },
        {
          text:
            "Il soggetto promotore (" +
            this.elements.denominazioneIstituto +
            ") dichiara sotto la propria responsabilità di essere abilitato a promuovere tirocini in Regione Piemonte in quanto rientrante nella seguente fattispecie, di cui all’art. 4.1 della DGR n. 85-6277 del 22 dicembre 2017: soggetto accreditato per i Servizi al Lavoro.",
          style: "bodyText"
        },
        {
          text:
            "Il soggetto ospitante (" +
            this.elements.denominazioneAzienda +
            ") dichiara sotto la propria responsabilità:",
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          ul: [
            {
              text:
                "che i tirocinanti non saranno impiegati per sostituire lavoratori assenti con diritto alla conservazione del posto di lavoro, per ricoprire ruoli o posizioni proprie dell’organizzazione aziendale o per sostituire lavoratori subordinati nei periodi di picco delle attività;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "di essere in regola con la normativa sulla salute e sicurezza sui luoghi di lavoro ai sensi del Dlgs. 81/2008 e smi e con la normativa di cui alla L. 68/1999 e smi.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "di non avere in corso procedure di sospensione dal lavoro o procedure di licenziamento collettivo e/o non avere effettuato nella medesima unità operativa e nei 12 mesi precedenti l’attivazione del tirocinio licenziamenti di lavoratori per mansioni equivalenti a quelle del tirocinio, fatti salvi quelli per giusta causa o per giustificato motivo soggettivo.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text: "Si conviene quanto segue:",
          bold: true,
          style: "bodyText",
          margin: [0, 5, 0, 10]
        },
        {
          text: "Art. 1. Oggetto della convenzione",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Il soggetto ospitante si impegna ad accogliere presso le sue strutture su proposta del soggetto promotore i soggetti in possesso dei requisiti previsti dalla disciplina regionale (di seguito denominati collettivamente “tirocinante”) per lo svolgimento di tirocini extracurriculari attivati ai sensi della DGR 85/2017, al fine di favorirne l’arricchimento del bagaglio di conoscenze, l’acquisizione di competenze professionali e l’inserimento o il reinserimento lavorativo.",
          style: "bodyText"
        },
        {
          text: "Art. 2. Disposizioni generali",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          ul: [
            {
              text:
                "Il tirocinio può essere attivato per una durata minima di 3 mesi e massima di 6, proroghe o rinnovi compresi, fatto salvo la maggiore durata prevista dalla disciplina per i soggetti svantaggiati o disabili, di cui all’art. 2 lett. f) della DGR 85/2017.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "L’impegno orario previsto non può essere inferiore a 20 ore settimanali e non può superare le 40 ore settimanali.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il tirocinio non può essere attivato nell’ipotesi in cui il tirocinante abbia avuto con il medesimo soggetto ospitante nei due anni precedenti all’attivazione del tirocinio un rapporto di lavoro, una collaborazione o un incarico o una prestazione lavorativa a qualsiasi titolo, salvo i casi tassativi disciplinati nei commi 6 e 7 dell’art. 8 della DGR 85/2017. In ogni caso non è mai possibile attivare il tirocinio per la stessa mansione già ricoperta dal tirocinante presso lo stesso soggetto ospitante.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Non può essere attivato più di un tirocinio per lo stesso soggetto presso il medesimo soggetto ospitante, anche se per mansioni diverse, così come previsto dall’art. 8 co. 4 della DGR 85/2017.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il tirocinante non può essere inserito in orari notturni e/o festivi fatto salvo il caso in cui l’attività specifica del soggetto ospitante giustifichi tali modalità e se finalizzato alle esigenze formative per il profilo professionale per cui è attivato il tirocinio. L’eventuale inserimento in turni deve essere adeguatamente motivato nel PFI.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Durante lo svolgimento del tirocinio l'attività di formazione ed orientamento è seguita e verificata da un tutor designato dal soggetto promotore in veste di responsabile didattico-organizzativo e da un tutor aziendale, indicato dal soggetto ospitante.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Non possono essere attivati tirocini oltre i limiti numerici stabiliti all’art. 7 della DGR 85/2017.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text: "Art. 3 Progetto formativo",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Per ciascun tirocinante inserito nell'azienda ospitante, in base alla presente Convenzione, viene predisposto un Progetto Formativo, sulla piattaforma informatica di sistema Piemonte “Portale Tirocini”, contenente:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "anagrafica: dati identificativi del tirocinante, dell’azienda o amministrazione pubblica, del soggetto promotore, del tutor individuato dal soggetto ospitante e del tutor o referente nominato del soggetto promotore; ",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "elementi descrittivi del tirocinio: tipologia di tirocinio, settore di attività economica dell’azienda (codici di classificazione ATECO) o dell’amministrazione pubblica, area professionale di riferimento dell’attività del tirocinio (codici di classificazione CP ISTAT), sede prevalente di svolgimento, estremi identificativi delle assicurazioni, durata, periodo di svolgimento, impegno orario del tirocinio, entità dell’importo corrisposto quale indennità al tirocinante; ",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "specifiche del progetto formativo: a) le attività previste come oggetto del tirocinio con riferimento alle aree di attività contenute nell’ambito della classificazione dei Settori Economico Professionali di cui al decreto interministeriale del 30 giugno 2015; b) obiettivi del tirocinio; c) competenze da acquisire con riferimento alla figura/profilo formativo e professionale di riferimento; d) processi/attività in cui opera il tirocinante associati, ove possibile, alle competenze da acquisire; e) modalità di svolgimento e strumenti;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "diritti e doveri delle parti coinvolte nel progetto di tirocinio: tirocinante, tutor del soggetto ospitante e referente o tutor del soggetto promotore",
              style: "bodyText"
              //margin: [0, 70, 0, 0]
            }
          ]
        },
        {
          text: "Art. 4. Indennità di partecipazione e rimborso spese",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Al tirocinante deve essere corrisposta, sulla base di quanto previsto all’art. 10 della DGR 85/2017,un’indennità minima di partecipazione al tirocinio pari ad € 600,00 per un impegno settimanale massimo di 40 ore.",
          style: "bodyText"
        },
        {
          text:
            "L’indennità è erogata per intero a fronte di una partecipazione minima al tirocinio del 70% su base mensile.",
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Art. 5. Obblighi del soggetto promotore",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Nel presidiare la qualità dell’esperienza di tirocinio il soggetto promotore deve:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "favorire l’attivazione dell’esperienza di tirocinio supportando il soggetto ospitante e il tirocinante nella fase di avvio nella gestione delle procedure amministrative e nella predisposizione del progetto formativo secondo le disposizioni e i modelli regionali oggetto di apposito provvedimento;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "individuare un referente o tutor quale responsabile organizzativo del tirocinio;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "promuovere il buon andamento dell’esperienza di tirocinio attraverso un’azione di accompagnamento e monitoraggio in itinere;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text: "provvedere alla predisposizione del PFI;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "rilasciare, sulla base della valutazione del soggetto ospitante, l’attestazione dei risultati;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "contribuire al monitoraggio territoriale dell’andamento dei tirocini;",
              style: "bodyText"
            },
            {
              text:
                "segnalare al soggetto ospitante l’eventuale mancato rispetto degli obiettivi contenuti nel PFI e delle modalità attuative del tirocinio, nonché ai competenti servizi ispettivi i casi in cui vi siano fondati motivi per ritenere che il tirocinante venga adibito ad attività non previste dal PFI o comunque svolga attività riconducibile ad un rapporto di lavoro. ",
              style: "bodyText"
            }
          ]
        },
        {
          text: "Art. 6. Obblighi del soggetto ospitante",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text: "Il soggetto ospitante deve:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "effettuare e trasmettere al soggetto promotore le comunicazioni di avvio del tirocinio, di proroga e di eventuale interruzione anticipata dello stesso; deve inoltre effettuare tempestivamente le comunicazioni di infortunio e trasmettere al soggetto promotore la relativa documentazione;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "designare un tutor aziendale con funzioni di affiancamento al tirocinante sul luogo di lavoro, individuato tra i propri lavoratori in possesso di competenze professionali adeguate e coerenti con il progetto formativo individuale. Nel caso di imprese con meno di 15 dipendenti e di imprese artigiane, il tutor può essere il titolare o un amministratore dell’impresa, un socio o un famigliare coadiuvante inserito nell’attività dell’impresa; ",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "assicurare la realizzazione del percorso di tirocinio secondo quanto previsto dal progetto formativo individuale e affidare ai tirocinanti esclusivamente attività coerenti con gli obiettivi formativi del tirocinio stesso e il loro impegno presso l’impresa non dovrà superare l’orario previsto dal progetto formativo;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "garantire, nella fase di avvio del tirocinio, un’adeguata informazione e formazione in materia di salute e sicurezza nei luoghi di lavoro ai sensi degli artt. 36 e 37 del D.lgs. 81/2008; al tirocinante deve essere inoltre garantita la sorveglianza sanitaria ai sensi dell’art. 41 del medesimo decreto;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "valutare l’esperienza svolta dal tirocinante ai fini del rilascio, da parte del soggetto promotore, dell’attestazione dell’attività svolta e delle competenze eventualmente acquisite;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "affidare ai tirocinanti esclusivamente attività coerenti con gli obiettivi formativi del tirocinio stesso e il loro impegno presso l’impresa non dovrà superare l’orario previsto dal contratto collettivo nazionale di lavoro di riferimento;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "far svolgere l’attività presso strutture aziendali (stabilimenti, sedi, reparti, uffici, ecc.) che rispettino le vigenti disposizioni normative in tema di prevenzione incendi, igiene e sicurezza del lavoro garantendo il rispetto di quanto previsto in materia di sorveglianza sanitaria ai sensi del D. Lgs n. 81/2008, “Testo Unico in materia di tutela della salute e sicurezza sui luoghi di lavoro” e s.m.i. ed a fornire, ai sensi dell’art. 37, all’avvio del tirocinio, sufficiente e adeguata formazione specifica in materia e, ove necessario, gli eventuali dispositivi di protezione individuale (DPI) e, ove necessario, farsi carico della visita medica;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "segnalare al Soggetto Promotore e agli istituti assicurativi ogni eventuale incidente occorso durante lo svolgimento del tirocinio, entro i tempi previsti dalla normativa vigente;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "effettuare la comunicazione di avvio del tirocinio (mod. UniLav), nei termini e nei modi previsti dal DGR n. 85-6277 del 22/12/2017 ;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "sospendere e/o interrompere l'attività di tirocinio, informando tempestivamente il Soggetto Promotore, nei casi in cui: a) la formazione alla sicurezza posseduta dal tirocinante, in relazione al D. Lgs. 81/2008, non sia idonea allo svolgimento di una o più attività previste dal Progetto formativo; b) dovessero difettare o venir meno le condizioni di incolumità del tirocinante, in riferimento allo svolgimento di una o di tutte le attività previste dal Progetto Formativo;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "garantire al tirocinante beneficiario del percorso, attraverso il Tutor esterno/aziendale, l’assistenza e la formazione necessarie al buon esito dell’attività prevista, nonché la dichiarazione delle competenze acquisite nel contesto di lavoro;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "consentire al Tutor scolastico di: a) monitorare l'attività mediante contatti telefonici e/o e-mail indirizzate al Tutor esterno; b) raggiungere e visitare gli studenti in tirocinio sul luogo effettivo di svolgimento dell'attività sia questo sede aziendale, cantiere mobile o reparto normalmente chiuso al pubblico.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "compilare il Questionario di soddisfazione dell'Azienda Ospitante al termine del periodo; è un documento online predisposto dall’Istituto per raccogliere informazioni sulla rispondenza dell’attività scolastica alle esigenze aziendali, utile anche all'analisi del fabbisogno di figure professionali sul territorio di riferimento;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "garantire un’organizzazione degli spazi tale da ridurre al massimo il rischio di prossimità e di aggregazione, e che vengano adottate misure organizzative di prevenzione e di protezione, contestualizzate al settore produttivo di riferimento, con riguardo alle specifiche esigenze delle persone con disabilità, di cui al “Documento tecnico sulle possibile rimodulazione delle misure di contenimento del contagio da SARS – CoV- 2 nei luoghi di lavoro e strategie di prevenzione pubblicato dall’INAIL e di cui alla normativa sanitaria nazionale”.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il soggetto ospitante è obbligato a stipulare l’assicurazione del tirocinante contro gli infortuni sul lavoro e per la responsabilità civile verso terzi. Le coperture assicurative devono riguardare anche le attività eventualmente svolte dal tirocinante al di fuori dell’azienda.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text:
            "Il soggetto ospitante non può realizzare più di un tirocinio con il medesimo tirocinante, fatta salva la possibilità di proroga circoscritta al limite massimo di durata indicato per ogni tipologia di tirocinio. ",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "Il Soggetto Ospitante si impegna, ove esiste, a permettere ai tirocinanti l’accesso al servizio di mensa aziendale o al buono pasto sostitutivo.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "Il Soggetto Ospitante si impegna a trasmettere al Soggetto Promotore, al termine del tirocinio, il registro delle presenze giornaliere.",
          style: "bodyText"
        },
        {
          text: "Art. 7. Sospensione e recesso anticipato del tirocinio",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          ul: [
            {
              text:
                "Il tirocinio può essere sospeso esclusivamente in caso di maternità/paternità o in caso di infortunio o malattia di lunga durata, intendendosi per tali quelli che si protraggono per una durata pari o superiore a 30 giorni solari per singolo evento. Il tirocinio può inoltre essere sospeso per i periodi di chiusura aziendale della durata di almeno 15 giorni solari consecutivi. Il periodo di sospensione non concorre al computo della durata complessiva del tirocinio secondo i limiti massimi indicati in disciplina.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il tirocinante può interrompere il tirocinio in qualsiasi momento, dandone comunicazione scritta al tutor del soggetto promotore ed al tutor aziendale.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il tirocinio può essere interrotto dal soggetto ospitante o dal soggetto promotore in caso di gravi inadempienze da parte di uno dei soggetti coinvolti o in caso di impossibilità a conseguire gli obiettivi formativi del progetto; le motivazioni a sostegno dell’interruzione devono risultare da apposita relazione.",
              style: "bodyText",
              margin: [0, 0, 0, 5],
              pageBreak: "after"
            }
          ]
        },
        {
          text: "Art. 8. Ulteriori consegne",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Le parti si impegnano a sottoscrivere la Convenzione e il Progetto Formativo Individuale prima della data di avvio del tirocinio. Gli originali sono conservati a cura del soggetto promotore che dovrà fornirne copia al soggetto ospitante. Al tirocinante dovrà essere consegnata copia del progetto formativo individuale, contenente gli estremi della convenzione.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "L’orario di permanenza in azienda è concordato tra il Soggetto Ospitante, il Tirocinante e il Soggetto Promotore, in funzione degli obiettivi formativi del tirocinio e valutando eventuali esigenze di studio del Tirocinante stesso. L'impegno orario settimanale non potrà eccedere il normale orario previsto per il personale interno, di norma, salvo diversa organizzazione aziendale, 8 ore giornaliere per 5 giorni settimanali.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "La presente convenzione ha una durata di un anno dalla data di sottoscrizione.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "Il soggetto ospitante con la sottoscrizione accetta le modifiche introdotte nella presente convenzione, a riguardo delle coperture assicurative (vedi art. 6).",
          style: "bodyText",
          margin: [0, 5, 0, 0]
        },
        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Firma SOGGETTO PROMOTORE",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: "Il Dirigente Scolastico",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.dirigenteIstituto,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right"
        },
        {
          text: "Firma SOGGETTO OSPITANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 70, 0, 0]
        },
        {
          text: "Legale Rappresentante",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.rappresentanteAzienda,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: this.elements.firmaAzienda,
          width: 200,
          alignment: "right"
        },
        {
          image: images.authFooter,
          width: 535,
          height: 80,
          margin: [0, 200, 0, 0]
        }
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        tableTextHigh: {
          fontSize: 8,
          background: "yellow"
        }
      }
    };
    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoIstituto_%%/g,
      this.elements.indirizzoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capIstituto_%%/g,
      this.elements.capIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaIstituto_%%/g,
      this.elements.provinciaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoIstituto_%%/g,
      this.elements.telefonoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_emailIstituto_%%/g,
      this.elements.emailIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleIstituto_%%/g,
      this.elements.codiceFiscaleIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dirigenteIstituto_%%/g,
      this.elements.dirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaDirigenteIstituto_%%/g,
      this.elements.luogoNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaDirigenteIstituto_%%/g,
      this.elements.dataNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pecAzienda_%%/g,
      this.elements.pecAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaRappresentanteAzienda_%%/g,
      this.elements.luogoNascitaRappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaRappresentante_%%/g,
      this.elements.dataNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_tipoAttivita_%%/g,
      this.elements.tipoAttivita
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );
    return completeDoc;
  }

  confirm() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchConfirmConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione accettata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchRefuseConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione rifiutata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }
}
